import { useCallback } from 'react';
import { Box, Stack, styled } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useForgotPassword } from 'hooks/useForgotPassword';
import { UserWorkspaceProfile } from 'models/UserWorkspaceProfile';
import { MobileHeader2 } from '@theme/styledComponents';
import { styledConstants } from '@theme/styledConstants';

const StyledBox = styled(Box)(() => ({
    marginTop: styledConstants.Header2TopMargin,
}));

const ChangePasswordButton = styled(LoadingButton)(({ theme }) => ({
    marginTop: '0.5rem',
    alignSelf: 'flex-end',
    flexShrink: 0,
    borderRadius: '20px',
    width: '10rem',
    height: '40px',
}));

export const MobileLogingInSection = (props: { user: UserWorkspaceProfile }) => {
    const { t } = useTranslation();
    const { user } = props;
    const { processForgotPassword, forgotPasswordPending } = useForgotPassword();

    const handleChangePassword = useCallback(() => {
        processForgotPassword({ email: user.email });
    }, [processForgotPassword, user.email]);

    return (
        <StyledBox>
            <Stack direction="column" alignItems="flex-start" width="100%">
                <MobileHeader2>{t('general.password')}</MobileHeader2>
                <ChangePasswordButton
                    loading={forgotPasswordPending}
                    disabled={!user.emailConfirmed}
                    variant="contained"
                    color="primary"
                    onClick={handleChangePassword}
                >
                    {t('profile.changePassword')}
                </ChangePasswordButton>
            </Stack>
        </StyledBox>
    );
};
